
































































































































































































































































































































































import { fromUnixTime, sub, isAfter } from 'date-fns';
import axios from 'axios';
import { get } from 'lodash';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoThumbnail from '@/components/Molecules/co-thumbnail/CoThumbnail.vue';
import CoDate from '@/components/Molecules/co-date/CoDate.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoLink from '@/components/Atoms/co-link/CoLink.vue';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';
import CoModal from '../co-modal/CoModal.vue';
import CoTag from '@/components/Atoms/co-tag/CoTag.vue';

export default {
    name: 'CoBookingModal',
    components: {
        CoModal,
        CoText,
        CoThumbnail,
        CoDate,
        CoFormGroup,
        CoLink,
        CoButton,
        CoConfirmation,
        CoTag,
    },
    props: {
        booking: {
            type: Object,
            required: false,
            default: () => {},
        },
        asAdmin: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            forUser: null, // user object for whom is booking
            byUser: null, // user object by who was it booked
            loading: false,
        };
    },
    computed: {
        currencyChar() {
            if (!this.$store || !get(this.$store, 'state.space.Currency', '')) {
                return '€';
            }

            const currency = get(this.$store, 'state.space.Currency', '').toUpperCase();

            if (currency === 'EUR') {
                return '€';
            }
            if (currency === 'USD') {
                return '$';
            }

            return currency;
        },
        idToNames() {
            const idsnames = {};

            if (this.booking.Resource) {
                idsnames[this.booking.Resource.ID] = this.booking.Resource.Name;

                const upgrades = get(this.booking, 'Upgrades', []);
                upgrades.forEach((element) => {
                    idsnames[element.OriginalID] = element.Name;
                });
            }
            return idsnames;
        },
        totalPrice() {
            if (!this.booking) {
                return 0;
            }

            if (this.booking.Price) {
                const tmp = this.booking.Price.PriceInCentsGross ? this.booking.Price.PriceInCentsGross / 100 : 0;
                return tmp.toFixed(2);
            }
            const tmp = this.booking.PriceInCentsGross ? this.booking.PriceInCentsGross / 100 : 0;
            return tmp.toFixed(2);
        },
        bookingPricePreviewDetailed() {
            const result = {
                Items: [],
                TaxRates: [],
                Subtotal: 0,
                TaxTotal: 0,
                Total: 0,
            };

            if (!this.booking.Price || !this.booking.Price.Items) {
                return result;
            }

            this.booking.Price.Items.forEach((element) => {
                const resource = {
                    name: this.idToNames[element.ResourceID],
                    quantity: element.Quantity,
                    tax: '',
                    displayprice: 0,
                    net: 0,
                    gross: 0,
                };

                const taxPercentage = element.TaxPercentage ? element.TaxPercentage : 0;
                resource.tax = `${taxPercentage}%`;
                if (element.TaxRateName) {
                    resource.tax += ` ${element.TaxRateName}`;
                }

                resource.displayprice = element.PriceInCentsBeforeCredits ? element.PriceInCentsBeforeCredits : 0;
                resource.net = element.PriceInCentsBeforeCreditsNet ? element.PriceInCentsBeforeCreditsNet : 0;
                resource.gross = element.PriceInCentsBeforeCreditsGross ? element.PriceInCentsBeforeCreditsGross : 0;

                result.Items.push(resource);

                if (element.CreditsInCents) {
                    const credits = {
                        name: `↳${this.$t('labels.credits')}`,
                        quantity: '',
                        tax: '',
                        displayprice: 0,
                        net: 0,
                        gross: 0,
                    };

                    credits.displayprice = -(element.CreditsInCents ? element.CreditsInCents : 0);
                    credits.net = -(element.CreditsInCentsNet ? element.CreditsInCentsNet : 0);
                    credits.gross = -(element.CreditsInCentsGross ? element.CreditsInCentsGross : 0);

                    result.Items.push(credits);
                }

                if (element.DiscountInCents) {
                    const discount = {
                        name: `↳${this.$t('labels.couponcode')} "${element.PromoCodeName}"`,
                        quantity: '',
                        tax: '',
                        displayprice: 0,
                        net: 0,
                        gross: 0,
                    };

                    discount.displayprice = -(element.DiscountInCents ? element.DiscountInCents : 0);
                    discount.net = -(element.DiscountInCentsNet ? element.DiscountInCentsNet : 0);
                    discount.gross = -(element.DiscountInCentsGross ? element.DiscountInCentsGross : 0);

                    result.Items.push(discount);
                }
            });

            result.Subtotal = this.booking.Price.PriceInCentsNet ? this.booking.Price.PriceInCentsNet : 0;
            result.Total = this.booking.Price.PriceInCentsGross ? this.booking.Price.PriceInCentsGross : 0;
            result.TaxTotal = result.Total - result.Subtotal;

            const taxRates = {};

            this.booking.Price.Items.forEach((element) => {
                const tax = {
                    name: element.TaxRateName,
                    quantity: '',
                    tax: `${element.TaxPercentage}%`,
                    displayprice: element.TaxInCents,
                    net: 0,
                    gross: 0,
                };

                const existingTaxRate = taxRates[`${element.TaxRateName}-${element.TaxPercentage}`];
                if (existingTaxRate) {
                    tax.displayprice += existingTaxRate.displayprice;
                }

                taxRates[`${element.TaxRateName}-${element.TaxPercentage}`] = tax;
            });

            for (const k in taxRates) {
                result.TaxRates.push(taxRates[k]);
            }
            return result;
        },
        bookingPricePreview() {
            if (!this.booking.Price) return [];

            const net = this.booking.Price.PriceInCentsNet ? this.booking.Price.PriceInCentsNet : 0;
            const gross = this.booking.Price.PriceInCentsGross ? this.booking.Price.PriceInCentsGross : 0;
            const taxamount = gross - net;
            const subtotal = {
                name: this.$t('labels.pricesubtotal'),
                amount: net,
            };

            const tax = {
                name: this.$t('labels.tax'),
                amount: taxamount,
            };

            const total = {
                name: this.$t('labels.total'),
                amount: gross,
            };

            const lines = [subtotal, tax, total];
            return lines;
        },
        creditsSummary() {
            if (!this.booking.Price || !this.booking.Price.Items) return null;

            const resourcePricePreview = this.booking.Price.Items.find(
                (item) => item.ResourceID === this.booking.ResourceID
            );
            if (!resourcePricePreview) return null;

            let used = resourcePricePreview.CreditsTimeUnitUsed ? resourcePricePreview.CreditsTimeUnitUsed : 0;
            let total = resourcePricePreview.CreditsTimeUnitTotal ? resourcePricePreview.CreditsTimeUnitTotal : 0;
            let before = resourcePricePreview.CreditsTimeUnitBeforeBooking
                ? resourcePricePreview.CreditsTimeUnitBeforeBooking
                : 0;
            let after = resourcePricePreview.CreditsTimeUnitAfterBooking
                ? resourcePricePreview.CreditsTimeUnitAfterBooking
                : 0;

            const cashCredits = resourcePricePreview.CashCredits;
            if (cashCredits) {
                used = resourcePricePreview.CashCreditsUsed ? resourcePricePreview.CashCreditsUsed : 0;
                total = resourcePricePreview.CashCreditsTotal ? resourcePricePreview.CashCreditsTotal : 0;
                before = resourcePricePreview.CashCreditsBeforeBooking
                    ? resourcePricePreview.CashCreditsBeforeBooking
                    : 0;
                after = resourcePricePreview.CashCreditsAfterBooking ? resourcePricePreview.CashCreditsAfterBooking : 0;
            }

            if (!used) {
                return null;
            }

            const res = [
                {
                    name: this.$t('labels.creditsbeforebooking'),
                    amount: before,
                },
                {
                    name: this.$t('labels.creditsused'),
                    amount: used,
                },

                {
                    name: this.$t('labels.creditsafterbooking'),
                    amount: after,
                },

                {
                    name: this.$t('labels.creditstotal'),
                    amount: total,
                },
            ];

            return {
                cashCredits,
                items: res,
            };
        },
        byUserUrl() {
            if (!this.byUser) {
                return '';
            }

            if (this.asAdmin) {
                return `/admin/community/member/view/${this.byUser.ID}`;
            }

            return `/profile/${this.byUser.Slug}`;
        },
        forUserUrl() {
            if (!this.forUser) {
                return '';
            }

            if (this.asAdmin) {
                return `/admin/community/member/view/${this.forUser.ID}`;
            }

            return `/profile/${this.forUser.Slug}`;
        },
        canCancel() {
            if (!this.booking || this.booking?.Status === 'cancelled') {
                return false;
            }

            if (this.asAdmin) {
                return true;
            }

            const start = fromUnixTime(this.booking.Start);
            const cancelPeriod = start;
            const diff = sub(cancelPeriod, {
                hours: this.booking.Resource.CancellationPeriod,
            });
            let canCancel = true;
            const now = new Date();
            if (isAfter(now, diff)) {
                canCancel = false;
            }

            return canCancel;
        },
        isCanceled() {
            return this.booking?.Status === 'cancelled';
        },
    },
    watch: {
        booking(val) {
            if (val) {
                this.$refs[`bookin-modal`].show();
            } else {
                this.$refs[`bookin-modal`].hide();
            }

            if (this.forUser && this.forUser === val.UserID && val.UserID !== '') {
                // skip loading again
            } else {
                this.forUser = null;
                if (val.UserID) {
                    this.getForUser(val.UserID);
                }
            }
            if (
                this.byUser &&
                this.byUser === val.UserID &&
                val.UserID !== '' &&
                this.forUser &&
                this.byUser.ID === this.forUser.ID
            ) {
                // skip loading again
            } else {
                this.byUser = null;
                if (val.CreatedByUserID) {
                    this.getByUser(val.CreatedByUserID);
                }
            }
        },
    },
    mounted() {
        if (this.booking) {
            this.$refs[`bookin-modal`].show();

            if (this.forUser && this.forUser === this.booking.UserID && this.booking.UserID !== '') {
                // skip loading again
            } else {
                this.forUser = null;
                if (this.booking.UserID) {
                    this.getForUser(this.booking.UserID);
                }
            }
            if (
                this.byUser &&
                this.byUser === this.booking.UserID &&
                this.booking.UserID !== '' &&
                this.forUser &&
                this.byUser.ID === this.forUser.ID
            ) {
                // skip loading again
            } else {
                this.byUser = null;
                if (this.booking.CreatedByUserID) {
                    this.getByUser(this.booking.CreatedByUserID);
                }
            }
        }
    },
    methods: {
        get,
        close() {
            this.$emit('closed');
        },
        openPriceOverviewDetails() {
            this.$refs['priceoverview'].show();
        },
        getForUser(ID) {
            this.$store
                .dispatch('adminGetUserByID', ID)
                .then((response) => {
                    this.forUser = response;
                    if (get(this.booking, 'CreatedByUserID', '') === this.forUser.ID) {
                        this.byUser = this.forUser;
                    }
                })
                .catch((error) => {});
        },
        getByUser(ID) {
            this.$store
                .dispatch('adminGetUserByID', ID)
                .then((response) => {
                    this.byUser = response;
                })
                .catch((error) => {});
        },
        cancelBooking() {
            let url = `/booking/v2/${this.booking.ID}`;

            if (this.asAdmin) {
                url = `/admin/booking/${this.booking.ID}`;
            }

            this.loading = true;
            axios({
                method: 'DELETE',
                url,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.$emit('canceled');
                })
                .catch((error) => {
                    this.$emit('failed', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
